<script>
export default {
  name: "StandardV2Header",
  props: {
    title: {
      type: String,
      default: ""
    },
    showBack: {
      type: Boolean,
      default: false
    },
    compactBack: {
      type: Boolean,
      default: false
    },
    actions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    visibleActions() {
      if (this.$isLacoste) {
        return this.actions.filter(a => a.key === "filter");
      }
      return this.actions;
    }
  },
  methods: {
    emitAction(action) {
      this.$emit("action", action);
    }
  }
};
</script>

<template>
  <button
    v-if="compactBack"
    type="button"
    class="standard-v2-privilege-detail__back"
    data-test="privilege-detail-back-btn"
    @click="$router.back()"
  >
    <font-awesome-icon :icon="['fas', 'chevron-left']" />
  </button>
  <header
    :class="['standard-v2-header', { 'is-lacoste': $isLacoste }]"
    data-test="standard-v2-header"
    v-else
  >
    <button
      v-if="showBack"
      type="button"
      class="standard-v2-header__back"
      data-test="standard-v2-header-back-btn"
      @click="emitAction({ key: 'back' })"
    >
      <font-awesome-icon :icon="['fas', 'chevron-left']" />
    </button>
    <div v-else class="standard-v2-header__spacer"></div>

    <div class="standard-v2-header__title" data-test="standard-v2-header-title">
      {{ title }}
    </div>

    <div
      id="standard-v2-header-extra"
      class="standard-v2-header__extra"
      data-test="standard-v2-header-extra"
    ></div>

    <div class="standard-v2-header__actions">
      <button
        v-for="action in visibleActions"
        :key="action.key"
        type="button"
        class="standard-v2-header__action"
        :data-test="`standard-v2-header-${action.key}-btn`"
        @click="emitAction(action)"
      >
        <font-awesome-icon :icon="action.icon" />
      </button>
    </div>
  </header>
</template>

<style lang="scss" scoped>
.standard-v2-header {
  position: sticky;
  top: 0;
  z-index: 15;
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr) auto auto;
  min-height: 50px;
  align-items: center;
  gap: 8px;
  padding: 16px 12px;
  border-radius: 0 0 24px 24px;
  background: #fff;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.08);
  font-size: var(--font-title-sm);
}

.standard-v2-header__back,
.standard-v2-header__action {
  display: inline-flex;
  width: 34px;
  height: auto;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  color: var(--primary-color);
  // font-size: var(--font-heading);
}

.standard-v2-header__spacer {
  width: 34px;
  height: auto;
}

.standard-v2-header__title {
  overflow: hidden;
  margin: 0;
  color: #2f2f2f;
  // font-size: var(--font-heading);a
  font-weight: 900;

  text-overflow: ellipsis;
  white-space: nowrap;
}

.standard-v2-header__extra {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;

  &:empty {
    display: none;
  }
}

.standard-v2-header__actions {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
}

.standard-v2-header.is-lacoste {
  --lacoste-header-radius: 0;
  border-radius: var(--lacoste-header-radius);
  box-shadow: none;
  padding: 12px 16px;
  min-height: 56px;
}

.standard-v2-header.is-lacoste .standard-v2-header__title {
  text-align: left;
  color: var(--primary-color);
  font-size: var(--font-heading);
  font-weight: 700;
}

.standard-v2-header.is-lacoste .standard-v2-header__back,
.standard-v2-header.is-lacoste .standard-v2-header__action {
  color: var(--primary-color);
  font-size: var(--font-title-sm);
}
</style>
